function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingConditions2 = function SvgLandingConditions2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 611 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_10_84)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.195,
    cy: 134.297,
    rx: 286.195,
    ry: 134.297,
    transform: "matrix(-0.997512 -0.0705025 0.216058 -0.976381 577.697 434.414)",
    fill: "#4DB7FE"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_10_84)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 293.228,
    cy: 217.877,
    rx: 242.5,
    ry: 79.4553,
    transform: "rotate(-180 293.228 217.877)",
    fill: "#F12EFF",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter2_f_10_84)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.03,
    cy: 170.08,
    rx: 158.03,
    ry: 170.08,
    transform: "matrix(0.428405 0.903587 -0.988728 0.149726 292.326 97.8957)",
    fill: "#139000"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_10_84",
    x: -69.7462,
    y: 46.4245,
    width: 781.952,
    height: 473.374,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 52,
    result: "effect1_foregroundBlur_10_84"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_10_84",
    x: -71.5719,
    y: 16.1214,
    width: 729.6,
    height: 403.511,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 61.15,
    result: "effect1_foregroundBlur_10_84"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_10_84",
    x: -110.064,
    y: 0.483559,
    width: 603.855,
    height: 531.343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.3,
    result: "effect1_foregroundBlur_10_84"
  }))));
};
export default SvgLandingConditions2;